import { render, staticRenderFns } from "./delivery-info.vue?vue&type=template&id=46fa6814&scoped=true"
import script from "./delivery-info.vue?vue&type=script&lang=js"
export * from "./delivery-info.vue?vue&type=script&lang=js"
import style0 from "./delivery-info.vue?vue&type=style&index=0&id=46fa6814&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fa6814",
  null
  
)

export default component.exports